import React, { useCallback, useContext } from 'react';

import { DragDropContext } from 'react-beautiful-dnd';

import { PacksDispatchContext } from './ApiProvider';
import ItemList from './itemsToPacks/ItemList';
import PackList from './itemsToPacks/PackList';

export default function ItemsToPacks({ items, packs, isLoaded, isContractor = false }) {
    const apiCall = useContext(PacksDispatchContext);

    const onDragStart = useCallback((result) => {}, []);
    const onDragUpdate = useCallback((result) => {}, []);
    const onDragEnd = useCallback((result) => {
        if (result.destination) {
            apiCall('itemToPack', { itemId: result.draggableId, packId: result.destination.droppableId });
        }
    }, []);

    if (!isLoaded) {
        return <></>;
    }

    return (
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} onDragUpdate={onDragUpdate}>
            <div className="tw-h-full tw-grid tw-grid-cols-3 tw-gap-4 tw-divide-x-2 tw-divide-gray-200">
                <div className="tw-min-h-0 tw-col-span-1">
                    <ItemList packItems={items} isContractor={isContractor} />
                </div>
                <div className="tw-min-h-0 tw-col-span-2 tw-pl-4">
                    <div className="tw-flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto">
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                            <div className="tw-p-2.5 tw-flex tw-gap-2 tw-items-center tw-text-sm tw-font-semibold tw-text-charcoal">
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div>{$t('Pack Name')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div>{$t('Cost Per Pack')}</div>
                                </div>
                                <div className="tw-basis-16 tw-shrink-0"></div>
                            </div>
                        </div>
                        <PackList packs={packs} isContractor={isContractor} />
                    </div>
                </div>
            </div>
        </DragDropContext>
    );
}
